import { useNavigate } from "react-router-dom";
import { money } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Check, Zap } from "lucide-react";

export function PricingCard({ pkg, onBuy }) {
  const navigate = useNavigate();
  const discount = pkg.original_price && pkg.original_price > pkg.price
    ? Math.round(((pkg.original_price - pkg.price) / pkg.original_price) * 100) : 0;

  return (
    <div
      data-testid={`package-card-${pkg.id}`}
      className={`relative rounded-2xl p-[1px] ${pkg.popular ? "bg-gradient-to-b from-purple-500 via-blue-500/40 to-transparent" : "bg-gradient-to-b from-white/10 to-transparent"} transition-transform duration-300 hover:-translate-y-2`}
    >
      {pkg.popular && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10 inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r from-purple-600 to-blue-600 text-white shadow-[0_0_16px_rgba(147,51,234,0.6)]">
          <Zap className="w-3 h-3" /> Most Popular
        </div>
      )}
      <div className="h-full rounded-2xl glass p-7 flex flex-col">
        <div className="flex items-baseline justify-between">
          <h3 className="font-heading text-lg font-bold text-white">{pkg.name}</h3>
          {discount > 0 && <span className="text-xs font-semibold text-emerald-400">Save {discount}%</span>}
        </div>
        <p className="text-xs uppercase tracking-widest text-purple-400 mt-1">{pkg.duration_label}</p>
        <div className="mt-5 flex items-end gap-2">
          <span className="font-heading text-4xl font-extrabold text-white">{money(pkg.price, pkg.currency)}</span>
          {pkg.original_price > pkg.price && (
            <span className="text-sm text-slate-500 line-through mb-1">{money(pkg.original_price, pkg.currency)}</span>
          )}
        </div>
        <ul className="mt-6 space-y-3 flex-1">
          {pkg.features?.map((f, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-slate-300">
              <Check className="w-4 h-4 text-neon-purple shrink-0 mt-0.5" /> {f}
            </li>
          ))}
        </ul>
        <Button
          data-testid={`buy-package-${pkg.id}`}
          onClick={() => (onBuy ? onBuy(pkg) : navigate(`/checkout/${pkg.id}`))}
          className={`mt-7 w-full font-semibold border-0 ${pkg.popular ? "glow-btn bg-gradient-to-r from-purple-600 to-blue-600 text-white" : "bg-white/10 text-white hover:bg-white/20"}`}
        >
          Order Now
        </Button>
      </div>
    </div>
  );
}
